import request from '@/utils/request'
const api = {
  GetOpenList: '/Portal/GetOpenList',
  GetHomeOpenList: '/Portal/GetHomeOpenList',
  GetIntegrityList: '/Portal/GetIntegrityList',
  GetBulletinContent: '/Portal/GetBulletinContent',
  GetBulletinTyContent: '/Portal/GetBulletinTyContent',
  GetBulletin: '/Portal/GetBulletin',
  GetNewsContent: '/Portal/GetNewsContent',
  GetSearchInfo: '/Portal/GetSearchInfo',
  AddOpinion: '/Portal/AddOpinion'
}
export function GetOpenList (param) {
  return request({
    url: api.GetOpenList,
    method: 'post',
    data: param

  })
}

export function GetHomeOpenList (param) {
  return request({
    url: api.GetHomeOpenList,
    method: 'post',
    data: param

  })
}

export function GetIntegrityList (param) {
  return request({
    url: api.GetIntegrityList,
    method: 'post',
    data: param

  })
}

export function GetBulletinContent (param) {
  return request({
    url: api.GetBulletinContent,
    method: 'post',
    data: param

  })
}

export function GetBulletinTyContent (param) {
  return request({
    url: api.GetBulletinTyContent,
    method: 'post',
    data: param

  })
}

export function GetBulletin (PrjId) {
  return request({
    url: api.GetBulletin + '?PrjId=' + PrjId,
    method: 'post'

  })
}

// eslint-disable-next-line camelcase
export function GetNewsContent (news_id) {
  return request({
    // eslint-disable-next-line camelcase
    url: api.GetNewsContent + '?news_id=' + news_id,
    method: 'post'
  })
}
export function GetSearchInfo (param) {
  return request({
    url: api.GetSearchInfo,
    method: 'post',
    data: param

  })
}
export function AddOpinion (param) {
  return request({
    url: api.AddOpinion,
    method: 'post',
    data: param

  })
}



// WEBPACK FOOTER //
// ./src/api/protal/index.js